export const GET_CLIENTES_REQUEST = 'GET_CLIENTES_REQUEST';
export const GET_CLIENTES_SUCCESS = 'GET_CLIENTES_SUCCESS';
export const GET_CLIENTES_FAILURE = 'GET_CLIENTES_FAILURE';
export const RESET_CLIENTES = 'RESET_CLIENTES';
